<template>

  <div class="page">

    <div id="root">
      <div class='div_left w_33'>
        <div class="div_base">
          <h4 class="engPlus">About Us</h4>
          <h3 class="chPlus">{{about}}</h3>
          <h4 class="aTitle">诚信合作 创新共享</h4>
          <span class="mainText">赢科天地秉持“合志赢科，共创未来”的运营理念，以助力中国高等教育事业发展为己任，以科技创新为核心战略，致力于成为中国领先的高等教育信息化产品和服务供应商，竭诚期待与您的合作，您的满意就是我们最大的动力和不懈追求的目标！</span>
        </div>
        <div class="div_left_top">
          <div class="float"></div>
          <h4 class="engPlus" style="margin-top: 20px;">About Us</h4>
          <h3 class="chPlus">{{about}}</h3>
          <div style="margin-top: 40px;margin-left: 20px;">
            <span class='btn1' v-for="(item,index) in btnData1" :key="index" @mouseenter="currentIndex=index" :class="{'btn':currentIndex==index}">{{item}}</span>
          </div>
          <div style="height: 1px;background-color: #ffffff;width: 98%;margin:10px auto;opacity: 0.4;"></div>
          <div style="margin:10px 20px;" v-for="(item,index) in content">
            <div class="mainTitle">{{item.title}}</div>
            <div class="mainText">{{item.text}}</div>
          </div>
		  <div class="moreStyle">
          <span class="btn" @click="goToNewPage('/about')">{{moreText}}</span>
		  </div>
        </div>
      </div>
      <div class='div_center w_33'>
        <div class="div_base">
          <h4 class='engPlus'>Product Center</h4>
          <h3 class="chPlus">{{product}}</h3>
          <h4 class="aTitle">学为中心 数字生态 智慧服务</h4>
          <span class="mainText">赢科天地围绕"以学为中心"的教育管理要求，充分应用人工智能、大数据、云计算、5G等先进信息技术，科学设计高校教育教学信息化体系架构，实现软件产品的智能采集、智能分析、智能决策功能。</span>
        </div>
        <div class="div_left_top">
          <div class="float"></div>
          <h4 class='engPlus' style="margin-top: 20px;">Product Center</h4>
          <h3 class="chPlus">{{product}}</h3>
          <div style="margin-top: 40px;margin-left: 20px;">
            <span class='btn1' v-for="(item,index) in btnData2" :key="index" @mouseenter="currentIndex1=index" :class="{'btn':currentIndex1==index}">{{item}}</span>
          </div>
          <div style="height: 1px;background-color: #ffffff;width: 98%;margin:10px auto;opacity: 0.4;"></div>
          <template v-for="item in conCenter">
            <span class="mainTitle">{{item.title}}</span><span class="mainText">{{item.text}}</span></br>
          </template>
          <div class="moreStyle">
			  <span class="btn"  @click="goToNewPage('/productcenter')">{{moreText}}</span>
		  </div>
        </div>

      </div>
      <div style="width: 33.3333%;position: relative;min-width: 400px;">

        <swiper class="swiper" :options="swiperOp" v-if='dataArray.length>1' ref='mySwiper'>
          <swiper-slide v-for="(item,index) in dataArray" :key='index'>
            <div class='div_right' :style="{background: 'url( '+ item.img +')',backgroundSize: '100% 100%'}">
              <div class="div_base">
                <h4 class='engPlus'>{{item.title}}</h4>
                <h3 class="chPlus">{{item.remark01}}</h3>
                <h4 class="aTitle">{{item.remark16}}</h4>
                <span class="mainText">{{item.remark17}}</span>
                <div class="moreStyle">
                  <span class="btn1" @mouseenter="currentIndex2=0" :class="{'btn':currentIndex2==0}" @click="goToNewPage('/consultingservices')">{{moreText}}</span>
                  <span v-if="index==0" class="btn1" @mouseenter="currentIndex2=1" @click="jumpPdf(item.id)" :class="{'btn':currentIndex2==1}">立即获取案例</span>
                </div>
              </div>
            </div>
          </swiper-slide>
          <!-- <swiper-slide>
            <div class='div_right rightBg1'>
              <div class="div_base">
                <h4 class='engPlus'>After-sales service</h4>
                <h3 class="chPlus">售后服务</h3>
                <span class="mainText" style="color:#ffffff;margin-top: 40px;">完善的价值交付服务体系，保障客户价值落地
                  聚焦项目实施关键要素，精细化、在线化项目管控，从底层硬件支撑环境到上层应用，从被动到主动发现问题，消除隐患。提供重点业务的运维运营保障，解决潜在风险。</span>
                <div class="moreStyle">
                  <span class="btn1" @mouseenter="currentIndex3=0" :class="{'btn':currentIndex3==0}" @click="goToNewPage('/consultingservices')">{{moreText}}</span>
                </div>
              </div>
            </div>
          </swiper-slide> -->
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>

        <!-- <img src="../assets/1-5.png" style="position: absolute;bottom: 0px;right: 0px;z-index: 100;" @click="showTalk=!showTalk" /> -->
      </div>

    </div>

    <div class="talk_div" v-show="showTalk">

      <div>
        <img src="../assets/2-1.png" /><label>立即与我们交谈</label>
      </div>
      <div style="justify-content: flex-end"><span class="talk_btn">开始聊天</span></div>

      <div style="height: 1px;background-color: #00000055;width: 100%;margin-top: 10px;"></div>

      <div>
        <img src="../assets/2-1.png" /><label>致电赢科</label>
      </div>
      <div style="justify-content: space-between">
        <span style="font-size: 1vw;color:#000000ee;line-height: 1vw;">1001001000</span>
        <span class="talk_btn">开始聊天</span>
      </div>

      <div style="height: 1px;background-color: #00000055;width: 100%;margin-top: 10px;"></div>
      <div>
        <img src="../assets/2-1.png" /><label>向技术顾问咨询</label>
      </div>
      <div style="justify-content: flex-end"><span class="talk_btn">开始聊天</span></div>
    </div>

  </div>

</template>

<script>
export default {
  data() {
    return {
      showTalk: false,
      index: 0,
      currentIndex: 0,
      currentIndex1: 0,
      currentIndex2: 0,
      currentIndex3: 0,
      content1: [
        {
          title: '赢科使命',
          text: '以信息技术赋能高校教育，助力高等教育现代化发展',
        },
        {
          title: '赢科愿景',
          text: '致力于成为中国领先的高等教育信息化产品和服务供应商',
        },
        {
          title: '赢科价值观',
          text: '诚信、敬业、务实、创新',
        },
		{
		  title: '赢科发展观',
		  text: '视野国际化、产品专业化、服务品质化、管理人性化',
		},
      ],
      content2: [
        {
          title: '',
          text: '赢科天地时刻铭记质量是企业生存的基石，坚持向客户提供高质量的产品和服务，让每位客户感受到公司致力于为客户创造价值的执着追求',
        },
        {
          title: '',
          text: '赢科天地尊重规则流程，坚持一次把事情做对，“专业、快速、细致、持续”是公司对客户郑重的服务承诺',
        },{
          title: '',
          text: '赢科天地致力于信息技术与教育教学的持续融合创新，不断地为客户创造超乎想象的价值',
        },
      ],
      content3: [
        {
          title: '资质荣誉',
          text: '赢科天地是北京市和中关村高新技术企业、中国先进技术企业、中国音像与数字出版协会音视频工程专业委员会理事单位、中国高等教育协会产教融合研究分会会员单位、北京高校优质课程研究会秘书长单位。',
        },
        {
          title: '产品及服务质量',
          text: '公司已通过CMMI3、ISO9000/20000系列质量管理体系认证，获得2项国家专利、90余项计算机软件著作权，被权威评估机构认定为3A级资信企业、重合同守信用企业、质量服务诚信企业。',
        },
        {
          title: '品牌力量',
          text: '经过十多年持续发展，公司综合实力、品牌影响力显著提升，先后荣获中国教育软件行业最具影响力品牌、中国自主创新企业、中国在线教育十强企业、质量信得过企业等殊荣，经权威机构评选，赢科天地获得全国教育软件行业市场用户首选品牌荣誉。',
        },
      ],
      content: [
        {
          title: '赢科使命',
          text: '以信息技术赋能高校教育，助力高等教育现代化发展',
        },
        {
          title: '赢科愿景',
          text: '致力于成为中国领先的高等教育信息化产品和服务供应商',
        },
        {
          title: '赢科价值观',
          text: '诚信、敬业、务实、创新',
        },
        {
          title: '赢科发展观',
          text: '视野国际化、产品专业化、服务品质化、管理人性化',
        },
      ],
	  conCenter: [
	    {
	      title: '',
	      text: '一体化教学业务管理系统',
	    },
	    {
	      title: '',
	      text: '本研教育版一体化教学业务管理系统',
	    },
	    {
	      title: '',
	      text: '职业教育版一体化教学业务管理系统',
	    },
	    {
	      title: '',
	      text: '职业院校教学诊改一体化平台',
	    },
	  ],
	  conCenter1: [
	    {
	      title: '一体化教学业务管理系统',
	      text: '',
	    },
	    {
	      title: '',
	      text: '本研教育版一体化教学业务管理系统',
	    },
	    {
	      title: '',
	      text: '职业教育版一体化教学业务管理系统',
	    },
	    {
	      title: '职业院校教学诊改一体化平台',
	      text: '',
	    },
	  ],
	  conCenter2: [
	    {
	      title: '',
	      text: '统一门户平台',
	    },
	    {
	      title: '',
	      text: '统一身份认证平台',
	    },
	    {
	      title: '',
	      text: '统一数据交换平台',
	    },
	    {
	      title: '',
	      text: '教学统计决策支持系统',
	    },{
	      title: '',
	      text: '······',
	    },
	  ],
	  conCenter3: [
	    {
	      title: '',
	      text: '排课系统',
	    },
	    {
	      title: '',
	      text: '在线教学系统',
	    },
	    {
	      title: '',
	      text: '学生成绩管理系统',
	    },
	    {
	      title: '',
	      text: '国际专业认证平台',
	    },{
	      title: '',
	      text: '······',
	    },
	  ],
	  conCenter4: [
	    {
	      title: '',
	      text: '智慧教室',
	    },
	    {
	      title: '',
	      text: '学生成绩查询打印一体机',
	    },
	    {
	      title: '',
	      text: '教务OA系统',
	    },
	    {
	      title: '',
	      text: '······',
	    },
	  ],
	  
      swiperOp: {
        effect: 'slide',
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        loop: true,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
      },
      btnData1: ['赢科文化', '赢科优势', '赢科荣誉'],
      btnData2: ['整体解决方案', '基础服务平台', '教学业务系统', '其他辅助产品'],
      about: '关于赢科',
      product: '产品中心',
      moreText: '了解更多',
      dataArray: '',
    }
  },
  methods: {
	  jumpPdf(id) {
	  	this.$router.push({
	  	  path: 'newsdetail',
	  	  query: { id: id },
	  	})
	  },
    goToNewPage(path) {
      this.$router.push(path)
    },
  },
  watch: {
    currentIndex(value) {
      if (value == 0) {
        this.content = this.content1
      } else if (value == 1) {
        this.content = this.content2
      } else {
        this.content = this.content3
      }
    },
	currentIndex1(value){
		if (value == 0) {
		  this.conCenter = this.conCenter1
		} else if (value == 1) {
		  this.conCenter = this.conCenter2
		} else if (value==2){
		  this.conCenter = this.conCenter3
		}else{
		  this.conCenter = this.conCenter4
		}
	}
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    },
  },
  mounted() {
    let url =
      this.HOST +
      'wzPage/getJson?id=C83B9FB09A5116B8E05509994F3826F5&moduleOrder=ordernum&contentOrder=ordernum&websiteid=4'
    url = this.$getJsonUrl(url)
    this.$axios.get(url).then((res) => {
      // console.log(res.data.content[0].children[0].children[0].list)
      this.dataArray = res.data.content[0].children[0].children[0].list
    })
  },
}
</script>
<style scoped>
@-webkit-keyframes bounceInDown {
  0% {
    -webkit-transform: translate3d(0, -3000px, 0);
    transform: translate3d(0, -3000px, 0);
  }

  60% {
    -webkit-transform: translate3d(0, 25px, 0);
    transform: translate3d(0, 25px, 0);
  }

  75% {
    -webkit-transform: translate3d(0, -10px, 0);
    transform: translate3d(0, -10px, 0);
  }

  90% {
    -webkit-transform: translate3d(0, 5px, 0);
    transform: translate3d(0, 5px, 0);
  }

  100% {
    -webkit-transform: none;
    transform: none;
  }
}

@keyframes bounceInDown {
  0% {
    -webkit-transform: translate3d(0, -3000px, 0);
    transform: translate3d(0, -3000px, 0);
  }

  60% {
    -webkit-transform: translate3d(0, 25px, 0);
    transform: translate3d(0, 25px, 0);
  }

  75% {
    -webkit-transform: translate3d(0, -10px, 0);
    transform: translate3d(0, -10px, 0);
  }

  90% {
    -webkit-transform: translate3d(0, 5px, 0);
    transform: translate3d(0, 5px, 0);
  }

  100% {
    -webkit-transform: none;
    transform: none;
  }
}

/* #root {
  color: white;
} */

.w_33 {
  width: 33.3333vw;
  min-width: 400px;
  min-height: 420px;
  /* height: calc(100vh - 270px); */
  height: 40vw;
  vertical-align: middle;
  display: inline-block;
  /* line-height: calc(100vh - 270px); */
  line-height: 40vw;
  text-align: center;
  /* cursor: pointer; */
}

.div_right {
  width: 33.3333vw;
  min-width: 400px;
  min-height: 420px;
}

.div_left {
  background-image: url(../assets/1-1.jpg);
  /* background-size: 100% calc(100vh - 270px); */
  background-size: 100% 40vw;
}

.div_center {
  background-image: url(../assets/1-2.jpg);
  /* background-size: 100% calc(100vh - 270px); */
  background-size: 100% 40vw;
}

#root {
  color: white;
  display: flex;
  width: 100%;
  min-width: 500px;
}



.div_left_top .float {
  background-color: #000000;
  opacity: 0.3;
  width: 33.3333vw;
  min-width: 400px;
  min-height: 420px;
  /* height: calc(100vh - 270px); */
  height: 40vw;
  position: absolute;
  z-index: -1;
}

.div_left:hover .div_left_top {
  display: flex;
  animation: bounceInDown 1s forwards;
}

.div_left:hover .div_base {
  display: none;
}

.div_center:hover .div_left_top {
  display: flex;
  animation: bounceInDown 1s forwards;
}

.div_center:hover .div_base {
  display: none;
}

h3,
h4 {
  margin-left: 20px;
}

span {
  padding: 0px 20px;
  word-break: break-all;
}

h4 {
  margin-top: 20px;
}

.div_base {
  display: flex;
  flex-direction: column;
  line-height: 1.5rem;
  /* height: calc(100vh - 270px); */
  height: 40vw;
  text-align: left;
}

.div_left_top {
  position: absolute;
  display: none;
 
  width: 33.3333vw;
  min-width: 400px;
  min-height: 420px;
  /* height: calc(100vh - 270px); */
  height: 40vw;
  line-height: 1.5rem;
  flex-direction: column;
  text-align: left;
}

.btn {
  border: 1px solid #ffffff;
  background-color: #ffffff;
  border-radius: 0.3vw;
  padding-top: 0.3vw;
  padding-bottom: 0.3vw;
  font-size: 1vw;
  line-height: 1vw;
  color: black;
  padding-left: 0.3vw;
  padding-right: 0.3vw;
  margin-right: 0.3vw;
  cursor: pointer;
}

.btn1 {
  border: 1px solid #ffffff;
  border-radius: 0.3vw;
  padding-top: 0.3vw;
  padding-bottom: 0.3vw;
  font-size: 1vw;
  line-height: 1vw;
  padding-left: 0.3vw;
  padding-right: 0.3vw;
  margin-right: 0.3vw;
  cursor: pointer;
}

ul li img {
  width: 40px;
  height: 40px;
  vertical-align: middle;
}

.div_base .title {
  margin-top: 120px;
}

.talk_div {
  width: 280px;
  background-color: #ffffff;
  position: absolute;
  left: calc(50vw - 150px);
  top: 135px;
}

.talk_div div {
  display: flex;
  align-items: center;
}

.talk_div img {
  width: 35px;
  height: 35px;
  padding: 5px;
}

.talk_btn {
  background-color: #6a9c67;
  margin: 10px;
  padding: 6px 18px;
  border-radius: 10px;
  font-size: 1vw;
  line-height: 1vw;
  color: white;
}

.talk_btn:hover {
  cursor: pointer;
}

.talk_div label {
  font-size: 1vw;
  line-height: 1vw;
}

.rightBg {
  position: relative;
  background-image: url(../assets/1-3.jpg);
  /* background-size: 100% calc(100vh - 270px); */
  background-size: 100% 40vw;
}

.rightBg1 {
  position: relative;
  background-image: url(../assets/1-4.jpg);
  /* background-size: 100% calc(100vh - 270px); */
  background-size: 100% 40vw;
}

.engPlus {
  font-size: 1.6vw;
  line-height: 1.6vw;
  margin-top: 10vw;
}

.chPlus {
  margin-top: 10px;
  font-size: 1.8vw;
  line-height: 1.8vw;
  font-weight: 600;
}

.aTitle {
  font-size: 1.2vw;
  line-height: 1.6vw;
  font-weight: 600;
  margin-top: 40px;
}

.mainTitle {
  font-weight: 550;
  font-size: 1.1vw;
  line-height: 1.5vw;
}

.mainText {
  font-size: 1vw;
  line-height: 120%;
}

.moreStyle {
  position: absolute;
  left: 20px;
  bottom: 5vw;
}

.swiper {
  width: 100%;
}

.swiper /deep/ .swiper-pagination {
  bottom: 2vw;
  left: 20px;
}

.swiper /deep/ .swiper-pagination-bullet-active {
  background-color: #fff !important;
  opacity: 1 !important;
}

.swiper /deep/ .swiper-pagination-bullet {
  margin: 0 4px;
  width: 30px;
  height: 5px;
  border-radius: 3px;
  background-color: transparent;
  border: 1px solid #fff;
  opacity: 0.6;
}
</style>
